module.exports = __webpack_public_path__ + "static/prof-nielsen-6532be38895d37572eda87fa23c6a600.png";